import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { AddressAutocompleteResult } from 'src/app/classes/address-autocomplete-result';
import { Geolocation } from '@capacitor/geolocation';
import { PlacesService } from 'src/app/services/places.service';
import { AddressAutocompletePrediction } from 'src/app/classes/address-autocomplete-prediction';

@Component({
  selector: 'app-address-autocomplete',
  templateUrl: './address-autocomplete.component.html',
  styleUrls: ['./address-autocomplete.component.scss'],
})
export class AddressAutocompleteComponent implements OnInit {
  @Output() setAddress = new EventEmitter<AddressAutocompleteResult>();

  fa = fa
  isLoading = false;
  address: AddressAutocompleteResult = new AddressAutocompleteResult();
  query = '';
  showDropdown = false;

  filteredOptions: AddressAutocompletePrediction[] = [];

  constructor(
    private placesService: PlacesService
  ) { }

  ngOnInit() { }

  onInputChange() {
    this.placesService.getPlacePredictions(this.query).subscribe(predictions => {
      
      this.filteredOptions = predictions
    });
  }

  selectOption(selected: AddressAutocompletePrediction) {
    this.showDropdown = false;

    this.placesService.getPlaceByPlaceId(selected.place_id).subscribe(place => {
      this.query = place.display
      this.address = place
      this.setAddress.emit(this.address);
    })
  }

  onBlur() {
    setTimeout(() => this.showDropdown = false, 150);
  }

  async getCoordinates() {
    this.isLoading = true;

    const position = await Geolocation.getCurrentPosition();

    this.placesService.getPlaceByCoordinates(
      position.coords.latitude,
      position.coords.longitude
    ).subscribe({
      next: (place) => {
        this.isLoading = false;

        this.query = place.display

        this.address = place
        this.address.lat = position.coords.latitude
        this.address.long = position.coords.longitude

        this.setAddress.emit(this.address);
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error)
      }
    })
  }
}
